'use es6';

import * as checked from '../../lib/checked';
export const Sort = checked.record({
  property: checked.any(),
  order: checked.any(),
  type: checked.any(),
  metricType: checked.any()
}, 'Sort').defaultValue({});
export const Sorts = checked.list(Sort, 'Sorts').defaultValue([]);